module.exports = __webpack_public_path__ + "static/media/img_landing09.85e5a7dd.png";